// extracted by mini-css-extract-plugin
module.exports = {"arrow":"AnimatedArrow_arrow__6osQz","animate":"AnimatedArrow_animate__3h2wR"};